import TeamMemberStyleWrapper from "./TeamMember.style";

const TeamMember = ({ avatar, name, designation, socialLinks }) => {
  return (
    <TeamMemberStyleWrapper>
      <div className="hermes_team_card">
        <div className="team_member_img">
          <img src={avatar} alt="hermes nft team avatar" />
        </div>
        <span className="member_name" data-text={name}><h3>{name}</h3></span>
        <span className="member_designation" data-text={designation}><h4>{designation}</h4></span>

        <div className="team_social_icon">
          <ul>
            {socialLinks?.map((item, i) => (
              <li key={i}>
                <a href={item.url}>{item.icon}</a>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </TeamMemberStyleWrapper>
  );
};

export default TeamMember;
